if (!customElements.get('slugger-lineup-grid')) {
  class SluggerLineupGrid extends HTMLElement {
    constructor() {
      super();
      this.handleCardClick = this.handleCardClick.bind(this);
      this.handleOutsideClick = this.handleOutsideClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleCardClick);
      document.addEventListener('click', this.handleOutsideClick);
      document.addEventListener('keydown', this.handleKeydown);
      this.syncTouchState();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleCardClick);
      document.removeEventListener('click', this.handleOutsideClick);
      document.removeEventListener('keydown', this.handleKeydown);
      this.syncTouchState();
    }

    handleCardClick(event) {
      const isTouchDevice = window.matchMedia('(hover: none), (pointer: coarse)').matches;
      const card = event.target.closest('.lineup-card');

      if (!isTouchDevice || event.detail === 0 || !card || !this.contains(card)) return;
      if (card.classList.contains('is-touch-open')) return;

      event.preventDefault();
      this.closeCards(card);
      card.classList.add('is-touch-open');
      this.syncTouchState();
    }

    handleOutsideClick(event) {
      const card = event.target.closest('.lineup-card');

      if (!card || !this.contains(card)) this.closeCards();
    }

    handleKeydown(event) {
      if (event.key === 'Escape') this.closeCards();
    }

    closeCards(exception) {
      this.querySelectorAll('.lineup-card.is-touch-open').forEach((card) => {
        if (card === exception) return;
        card.classList.remove('is-touch-open');
        card.blur();
      });

      this.syncTouchState();
    }

    syncTouchState() {
      const hasOpenCard = Boolean(document.querySelector('.collection-grid-list .lineup-card.is-touch-open'));

      document.body.classList.toggle('lineup-card-is-open', hasOpenCard);
    }
  }

  customElements.define('slugger-lineup-grid', SluggerLineupGrid);
}
